import { Button } from '@creditornot/cb-button';
import { cbSemanticCssVars, elevationCss } from '@creditornot/cb-ingredients';
import { ModalContent, ModalFooter, ModalHeader } from '@creditornot/cbt-modal';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { WoltModal } from 'common/components';

type Props = {
  className?: string;
  isOpen: boolean;
  close: () => void;
};

const Root = styled(WoltModal)`
  padding: 0;
  width: 320px;
`;

const Container = styled.div`
  ${elevationCss(16)}
  background: ${cbSemanticCssVars.surfaceMain};
  border-radius: 8px;
  color: ${cbSemanticCssVars.textSecondary};
`;

const ContinueButton = styled(Button).attrs({
  type: 'button',
  size: 'small',
  variant: 'primary',
})`
  margin-inline-start: auto;
`;

const PosWarningInner = ({ close }: Props) => {
  return (
    <>
      <ModalHeader onCloseClick={close}>
        <FormattedMessage id="merchant-integrations.pos-integrated-venue-header" />
      </ModalHeader>
      <ModalContent>
        <FormattedMessage id="merchant-integrations.pos-integrated-venue-message" />
      </ModalContent>
      <ModalFooter>
        <ContinueButton
          onClick={() => {
            close();
          }}
        >
          <FormattedMessage id="state.continue" />
        </ContinueButton>
      </ModalFooter>
    </>
  );
};

const PosWarningModal = ({ className, close, isOpen }: Props) => {
  return (
    <Root className={className} isOpen={isOpen}>
      <Container>
        <PosWarningInner isOpen={isOpen} close={close} />
      </Container>
    </Root>
  );
};

export default PosWarningModal;
